import { useSelector } from "react-redux";
import { Route, Switch } from "react-router";
import { OPEN_BANKING_URL, PROFILE_PAYMENTS_URL } from "../../../const/URL.const";
import { OpenBankingContainer } from "../../../container/OpenBankingContainer";
import { IReduxAppState } from "../../../reducers";
import { MenuContainerTabs } from "../../Routes";
import PaymentContainer from "./PaymentContainer";
import { useFlags } from "launchdarkly-react-client-sdk";



export function PaymentsRoute() {
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { venueData: venue, venueSettings } = useSelector((state: IReduxAppState) => state.venue[venueId]);
    const { hasObAccess } = useFlags();

    return <Switch>
        <Route exact path={PROFILE_PAYMENTS_URL}>
            {venueSettings?.visibility_merchant_dashboard_payments
                ? <PaymentContainer
                    tab={ hasObAccess ?  MenuContainerTabs.PAYMENTADULT : MenuContainerTabs.PAYMENTS}
                    venueId={venue!.id!}
                    venueName={venue!.venue_name || "forms.mysettings.title"}
                    acquirerName={venueSettings.acquirer_name}
                    paymentProcessor={venue!.payment_processor}
                    onboardingSource={venue!.onboarding_source}
                />
                : null}
        </Route>
        {hasObAccess && <Route path={OPEN_BANKING_URL}>
            <OpenBankingContainer tab={MenuContainerTabs.OPENBANKING} />
        </Route>}
    </Switch>
}